import { Injectable, Renderer2, RendererFactory2, DOCUMENT, inject } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { GlobalSpinnerState } from '@nx-customer-apps/shared/interfaces';

const initGlobalSpinnerState: GlobalSpinnerState = {
    isShown: false,
    loadingText: 'LOADER.LOADING'
};

@Injectable({
    providedIn: 'root'
})
export class GlobalSpinnerService {
    private document = inject<Document>(DOCUMENT);
    private rendererFactory = inject(RendererFactory2);

    private renderer: Renderer2;
    private state$: BehaviorSubject<GlobalSpinnerState> = new BehaviorSubject(initGlobalSpinnerState);
    private cancel$: Subject<void> = new Subject();

    constructor() {
        this.initBodyElementChanges();
    }

    public get state(): Observable<GlobalSpinnerState> {
        return this.state$.asObservable();
    }

    public next(state: GlobalSpinnerState): void {
        this.state$.next({ ...state, isShown: true });
    }

    public reset(): void {
        this.state$.next(initGlobalSpinnerState);
    }

    public isCanceled$(): Observable<void> {
        return this.cancel$.asObservable();
    }

    public cancel(): void {
        this.cancel$.next();
    }

    private initBodyElementChanges(): void {
        this.renderer = this.rendererFactory.createRenderer(null, null);
        this.state.subscribe(state => {
            if (state.isShown) {
                this.renderer.addClass(this.document.body, 'ca-overflow-hidden');
            } else {
                this.renderer.removeClass(this.document.body, 'ca-overflow-hidden');
            }
        });
    }
}
